export default function EntidadeContextoManagerService($rootScope, userAccountsService, acessoService) {
  const getApplicationContext = () => {
    return 'EntidadeContextoHolderService';
  }

  const resolve = (contexto) => {
    return acessoService.getAcesso(contexto)
      .then(acesso => userAccountsService.entitiesInfo(acesso.values.entity).then((info) => {
        acesso.nome = info[0].name;
        $rootScope.$emit('gerenciador.acessos.entidade.selecionada', { entidade: acesso });
        return acesso;
      }));
  };

  return {
    getApplicationContext: getApplicationContext,
    resolve: resolve,
  }
}

EntidadeContextoManagerService.$inject = [
  '$rootScope',
  'UserAccountsService',
  'AcessoService'
];
